module.exports = "/img/1.fd8ee3.webp";